import styled from 'styled-components';

export default styled.div`
  grid-area: display;
  padding: 0.5rem 0 0.5rem 0.5rem;
  display: grid;
  align-content: start;
  justify-content: center;
`;
